module.exports = __webpack_public_path__ + "static/media/bgLineCasino.06917712.svg";